import Blog from "../../components/blog/Blog";
import {
  Banner,
  Title,
  Desc,
  Container,
  Image,
  Input,
  Search,
  Button,
  SearchSection,
  BlogList,
} from "./Blogs.Elements";
import "./blogs.css";
import axios from "axios";
import { useEffect, useState } from "react";
import Pagination from "../../components/pagination/Pagination";
import SubscribeSection from "../../components/subscribe/Subscribe";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";

const Blogs = () => {
  const [blogs, setBlogs] = useState([]);
  const [isBlogsFetching, SetIsBlogsFetching] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState();
  const [searchByName, setSearchByName] = useState("");
  const [filterByName, setFilterByName] = useState("");

  useEffect(() => {
    const getAllBlogs = async () => {
      SetIsBlogsFetching(true);
      let feedURL;
      if (filterByName != "") {
        feedURL = `https://sumail-code.onrender.com/api/v1/blogs?filter=${filterByName}&page=${page}`;
        // console.log("filter has some value");
      } else {
        feedURL = `https://sumail-code.onrender.com/api/v1/blogs?page=${page}`;
      }
      try {
        const res = await axios.get(feedURL);
        setBlogs(res.data.data.blogs);
        setTotalPages(Math.ceil(res.data.totalDocs / 3));
        // console.log("totalPages", totalPages);
        // res.data.results
      } catch (err) {
        console.log(err);
      }
      SetIsBlogsFetching(false);
    };

    getAllBlogs();
  }, [page, filterByName]);

  const handleNameSearch = () => {
    // console.log(searchByName);
    setFilterByName(searchByName);
    setPage(1);
  };

  return (
    <>
      <div className='application'>
        <Header view='blog' />
        <Container>
          <Banner>
            <Title className='title'>BLOGS & ARTICLES</Title>
            <Desc className='desc'>
              We’d love to write an article or blog that you’re curious to read.
              Please fill the details in contact form with topic or technology
              on which you need an article.
            </Desc>
            <Image src='https://res.cloudinary.com/sumailcodes/image/upload/v1653210982/blog/blogwriting_vlsrvu.jpg' />
          </Banner>
          <SearchSection>
            <Search>
              <Input
                type='text'
                value={searchByName}
                onChange={(e) => setSearchByName(e.target.value)}
              />
              <Button onClick={handleNameSearch}>Search</Button>
            </Search>
          </SearchSection>

          {isBlogsFetching && (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <div className='spinner'></div>
            </div>
          )}

          {blogs.length > 0 && (
            <>
              <BlogList>
                {blogs.map((blog, id) => (
                  <Blog blog={blog} key={id} />
                ))}
              </BlogList>

              <Pagination
                page={page}
                setPage={setPage}
                totalPages={totalPages}
              />
            </>
          )}
          <SubscribeSection />
        </Container>
      </div>
      <div
        style={{
          backgroundColor: "#2f3133",
          color: "white",
          width: "100%",
        }}
      >
        <Footer />
      </div>
    </>
  );
};

export default Blogs;
